import React, { memo } from 'react';
import { Modal, Button, Descriptions, Tag } from 'antd';
import moment from 'moment';
import styles from '../styles/DriverLogs.module.css';

const LogDetailsModal = memo(({ visible, selectedLog, onClose }) => {
    return (
        <Modal
            title={<span className={styles.modalTitle}>Detalle del Registro #{selectedLog?.id}</span>}
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" type="primary" onClick={onClose} className={styles.closeButton}>
                    Cerrar
                </Button>
            ]}
            width={700}
            bodyStyle={{ padding: '1.5rem' }}
            centered
        >
            {selectedLog && (
                <div className={styles.modalContent}>
                    <Descriptions bordered size="small" column={2} layout="vertical">
                        <Descriptions.Item label={<span className={styles.boldText}>Motorista</span>}>
                            {selectedLog.driver_id ? (
                                <div className={styles.driverInfoContainer}>
                                    <span className={styles.driverName}>
                                        {selectedLog.driver_id.name} {selectedLog.driver_id.last_name || ''}
                                    </span>
                                    <span className={styles.driverSubText}>
                                        ID: {selectedLog.driver_id.id} | Cód: {selectedLog.driver_id.employee_id || 'N/A'}
                                    </span>
                                    {selectedLog.driver_id.email && <span className={styles.driverSubText}> {selectedLog.driver_id.email}</span>}
                                </div>
                            ) : 'N/A'}
                        </Descriptions.Item>
                        <Descriptions.Item label={<span className={styles.boldText}>Orden ID</span>}>{selectedLog.order_id?.id || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label={<span className={styles.boldText}>Acción</span>}>
                            <Tag className={styles.orangeTag}>{selectedLog.action}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label={<span className={styles.boldText}>Fecha</span>}>
                            {selectedLog.register_date ? moment(selectedLog.register_date).format('DD/MM/YYYY HH:mm A') : 'N/A'}
                        </Descriptions.Item>
                    </Descriptions>

                    <div>
                        <div className={styles.eventDetailsTitle}>Detalles del Evento:</div>
                        <Descriptions bordered column={1} size="small" className={styles.eventDetailsContainer}>
                            {Object.entries(selectedLog.parsedDetails || {}).map(([key, val]) => (
                                <Descriptions.Item label={<span className={styles.jsonKey}>{key}</span>} key={key}>
                                    {typeof val === 'object' ? (
                                        <pre className={styles.jsonPre}>
                                            {JSON.stringify(val, null, 2)}
                                        </pre>
                                    ) : (
                                        <span className={styles.jsonValue}>{String(val)}</span>
                                    )}
                                </Descriptions.Item>
                            ))}
                        </Descriptions>
                    </div>
                </div>
            )}
        </Modal>
    );
});

export default LogDetailsModal;
